import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBoxSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBoxSparkle"><Path d="M12 3L13 1L14 3L16 4L14 5L13 7L12 5L10 4L12 3Z" fill="currentColor"/><Path d="M6.66667 4.66667L7.5 3L8.33333 4.66667L10 5.5L8.33333 6.33333L7.5 8L6.66667 6.33333L5 5.5L6.66667 4.66667Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M19.3025 3.45789L20.5421 4.30247L17.3416 8.99999H20V22H4V8.99999H15.5265L19.3025 3.45789ZM9 13V14.5H15V13H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBoxSparkle;
